export const VALID_EXTENSIONS = ['png', 'jpg', 'jpeg', 'mp3', 'mp4', 'pdf', 'txt', 'vcf'];
